import { ApiLanguages } from '@/components/Global/I18N/domain';
import { AbsenceTypeResponseDto } from '@/domain/myOrganization';
import { PREDEFINED_ABSENCE_TYPE } from '@/pages/AdministratorPanel/ManageRequests/AbsenceTypes/constants';
import { ACCOUNT_ROLE, ORDER, ORDER_BY } from '@/utils/enums/common';
import { DELETION_STATUS, REQUEST_STATUS, REQUESTS_PERIOD_SELECT } from '@/utils/enums/requestsPage';

export interface AbsenceResponseDto {
    _id: string;
    userId: string;
    organizationId: string;
    from: string;
    to: string;
    type: PREDEFINED_ABSENCE_TYPE;
    status: REQUEST_STATUS;
    comment: string;
    totalWorkDays: number;
    reportedByManagerId: null | string;
    statusInRequest?: DELETION_STATUS;
    absenceTypeId: string;
    isOneDay: boolean;
    createdAt: string;
    updatedAt: string;
    hasPermissionForAcceptance: boolean;
    allowOverbooking?: boolean;
    isOverLimit?: boolean | null;
    userDto: {
        credentialId: string;
        username: string;
        firstName: string;
        lastName: string;
        email: string;
        activated: boolean;
        banned: boolean;
        roles: {
            credentialId: string;
            role: ACCOUNT_ROLE;
        }[];
        language: ApiLanguages;
        languageUpdatedAt: string;
        profilePictureUrl: string;
    };
}

export interface AbsenceWithTypeData extends AbsenceResponseDto {
    typeData: AbsenceTypeResponseDto | undefined;
}

export const checkIsOverLimitAndNotAllowed = (
    request: Pick<AbsenceResponseDto, 'isOverLimit' | 'allowOverbooking'>
): boolean => request.isOverLimit === null || (!!request.isOverLimit && !request.allowOverbooking);

export const OVER_LIMIT_TOOLTIP_SX = {
    maxWidth: '132px',
    textAlign: 'center',
    padding: '5px 10px',
    lineHeight: '16px',
    letterSpacing: '0.2px',
};

export interface ChangeHistoryStatusResponseDto {
    changes: {
        absenceId: string;
        createdAt: string;
        fieldName: string;
        id: string;
        newValue: string;
        oldValue: string;
        organizationId: string;
        updatedAt: string;
        userId: string;
    };
    changesBy: {
        activated: boolean;
        banned: boolean;
        credentialId: string;
        email: string;
        firstName: string;
        lastName: string;
        language: string;
        languageUpdatedAt: string;
        profilePictureUrl: string;
        username: string;
    };
}

export interface AllRequestsParamsDto {
    userId?: string;
    filterManagerInclusive?: boolean;
    searchPhase?: string;
    filterManagerId?: string;
    status?: (REQUEST_STATUS | DELETION_STATUS)[];
    endDate?: string;
    startDate?: string;
    orderBy?: ORDER_BY;
    order?: ORDER;
    absenceIds?: string[];
    includeArchived?: boolean;
    pageSize: number;
    page: number;
    requestListType?: string;
    absenceTypeId?: string;
}

export interface DateRange {
    startDate: string;
    endDate: string;
}

export interface DatePickerRange {
    startDate: Date | null;
    endDate: Date | null;
}

export interface RequestsListFilters {
    status: Array<REQUEST_STATUS | DELETION_STATUS>;
    period: REQUESTS_PERIOD_SELECT;
    customPeriodDates: DatePickerRange | null;
    order: ORDER;
    onlyOwn?: boolean;
    absenceType?: AbsenceTypeResponseDto | '';
}
